import React from 'react';

import { FieldProps } from '@api';
import { Input } from '@ui-library/input';

import { BaseTextField } from './baseTextField';

export const SecretTextField: React.FC<FieldProps<'textField'>> = ({ fieldConfig }) => (
  <BaseTextField fieldConfig={fieldConfig}>
    <Input.Password
      placeholder={fieldConfig.placeholder}
      disabled={fieldConfig.disabled}
      variant={fieldConfig.variant}
    />
  </BaseTextField>
);
